module.exports = __webpack_public_path__ + "5e327f04e1c9e710a3fc23201164943f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/temp.jpg
// module id = 463
// module chunks = 0